import { AwardsApi } from '../clients';

// Passthrough: the client already returns { blob, filename }, and there is no
// wire shape to normalise for a raw file download.
export const downloadCycleExport = (params) => AwardsApi.downloadCycleExport(params);
